import styled from "styled-components";

export const CheckOutContainer = styled.section`
    width: 30%;
    margin: 10px auto;
`